export const facilitiesHero = {
  title: '施設・設備紹介',
  titleEn: 'FACILITIES',
  lead: '本校は東京・お台場に位置し、講義と実技演習を行う学びの場です。',
};

export const campusParagraphs = [
  '本校は、東京湾を望むお台場に位置します。落ち着いた環境の中で、講義と実技演習の双方に取り組める学びの場です。ゆりかもめ「東京国際クルーズターミナル駅」「テレコムセンター駅」より各徒歩約5分、臨海副都心の洗練された街並みの中に校舎を構えています。',
  '校内には、講義を行う教室スペースと、実際に手を動かして学ぶ実技演習スペースを備えています。受講生の皆様が集中して学べる落ち着いた環境を整え、定員6名の少人数制にふさわしい、密度の高い学びの空間を提供します。',
  '校舎の見学は完全予約制で承っています。実際の雰囲気をご覧いただき、学びのイメージを具体化していただければ幸いです。見学は授業日（土日）以外の平日にも対応しております（所要時間の目安：30分程度）。',
];

export const facilityCards = [
  {
    icon: 'ri-restaurant-line',
    title: 'テーブルセッティング演習什器',
    description:
      'フォーマルからカジュアルまで、シーンに応じたテーブルコーディネートを学ぶための什器を備えています。カトラリーやグラスの配置、ナプキンの折り方まで、実際に手を動かしながら習得します。',
    status: 'available' as const,
  },
  {
    icon: 'ri-cup-line',
    title: 'ティー・コーヒーサービス設備',
    description:
      '紅茶やコーヒーの適切な抽出から、美しいサーブの所作までを実習できる設備を整えています。温度管理や注ぎ方、ゲストへの所作まで、一連の流れを体得します。',
    status: 'available' as const,
  },
  {
    icon: 'ri-t-shirt-line',
    title: '衣類ケア実習環境',
    description:
      'アイロンがけやスチーマーの取り扱い、衣類の素材に応じた適切なケア方法を学ぶ実習環境です。シャツの仕上げからスーツの手入れまで、執事に求められる衣類管理の技術を習得します。',
    status: 'available' as const,
  },
  {
    icon: 'ri-community-line',
    title: 'ロールプレイング用スペース',
    description:
      '実際の邸宅やホテルの場面を想定したロールプレイング演習を行うスペースです。講師がゲスト役となり、受講生の皆様が執事として対応する実践的な訓練を繰り返し行います。',
    status: 'available' as const,
  },
  {
    icon: 'ri-door-open-line',
    title: '来客対応・出迎え演習エリア',
    description:
      'エントランスでの出迎えから、コートのお預かり、お見送りまでの所作を実習するエリアです。第一印象を左右する出迎えの技術を、実際の動線に沿って体得します。',
    status: 'preparing' as const,
  },
  {
    icon: 'ri-glasses-line',
    title: 'ワイン・飲料サービス演習設備',
    description:
      'ワインの適切な開栓やデキャンタージュ、グラスへの注ぎ方など、飲料サービスに特化した実習環境を準備中です。テイスティングの基本知識もあわせて学べる設備を予定しています。',
    status: 'preparing' as const,
  },
];

export const facilitiesFaqs = [
  {
    question: '施設の見学はできますか？',
    answer:
      'はい。完全予約制で見学を承っています。お問い合わせフォームまたはお電話（平日10:00〜17:00）よりご予約ください。',
  },
  {
    question: '実技の設備は整っていますか？',
    answer:
      'テーブルセッティングやティーサービス、衣類ケアなどの実習に必要な環境を整えています（一部は開校に向けて準備中です）。',
  },
  {
    question: '校舎はどこにありますか？',
    answer:
      '東京・お台場（江東区青海）にあります。最寄りはゆりかもめ「東京国際クルーズターミナル駅」「テレコムセンター駅」で、各徒歩約5分です。',
  },
];

export const facilitiesRelatedPages = [
  {
    title: 'アクセス',
    description: '校舎への行き方と完全予約制のご案内',
    href: '/access',
  },
  {
    title: 'アカデミー概要',
    description: '日本執事アカデミーの全体像',
    href: '/about',
  },
  {
    title: '実践トレーニング',
    description: '現場を想定した実践的な学び',
    href: '/training',
  },
  {
    title: '個別相談予約',
    description: 'オンライン可・無料の個別相談',
    href: '/consultation',
  },
];